"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearReferrer = exports.storeReferrer = exports.getOrCreateInviteCode = exports.logVisit = exports.saveAddress = exports.getInvitedById = void 0;
var debug_1 = require("debug");
var log = (0, debug_1.default)("sharemint");
var logError = (0, debug_1.default)("sharemint:error");
var DEFAULT_BASE_URI = "https://sharemint.xyz";
var QUERY_PARAM = "r";
var LOCAL_STORAGE_KEY = "sharemint:invitedById";
function getInvitedById() {
    var invitedById = "";
    location.search
        .substring(1)
        .split("&")
        .forEach(function (item) {
        var split = item.split("=");
        if (split[0] === QUERY_PARAM)
            invitedById = split[1];
    });
    return invitedById;
}
exports.getInvitedById = getInvitedById;
function saveAddress(options) {
    return __awaiter(this, void 0, void 0, function () {
        var slug, address, email, transactionHash, referUrl, inviteCode, attributionModel, invitedById, url, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    slug = options.slug, address = options.address, email = options.email, transactionHash = options.transactionHash, referUrl = options.referUrl, inviteCode = options.inviteCode, attributionModel = options.attributionModel;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    invitedById = inviteCode || attributionModel === "last-click"
                        ? getInvitedById() || localStorage.getItem(LOCAL_STORAGE_KEY)
                        : localStorage.getItem(LOCAL_STORAGE_KEY) || getInvitedById();
                    if (!invitedById)
                        return [2 /*return*/];
                    log("Saving address: ".concat(address || email));
                    url = referUrl || "".concat(DEFAULT_BASE_URI, "/api/external/save");
                    return [4 /*yield*/, fetch(url, {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({
                                address: address,
                                email: email,
                                transactionHash: transactionHash,
                                slug: slug,
                                invitedById: invitedById,
                            }),
                        })];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    error_1 = _a.sent();
                    logError("Error saving user");
                    logError(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.saveAddress = saveAddress;
function logVisit(options) {
    return __awaiter(this, void 0, void 0, function () {
        var slug, referUrl, url, invitedById;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    slug = options.slug, referUrl = options.referUrl;
                    url = referUrl || "".concat(DEFAULT_BASE_URI, "/api/external/visit");
                    invitedById = getInvitedById();
                    if (!invitedById)
                        return [2 /*return*/];
                    return [4 /*yield*/, fetch(url, {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({ slug: slug, code: invitedById }),
                        })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.logVisit = logVisit;
function getOrCreateInviteCode(options) {
    return __awaiter(this, void 0, void 0, function () {
        var address, url, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    address = options.address;
                    url = "".concat(DEFAULT_BASE_URI, "/api/external/get-or-create-invite-code");
                    return [4 /*yield*/, fetch(url, {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({ address: address }),
                        })];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.getOrCreateInviteCode = getOrCreateInviteCode;
function storeReferrer() {
    var invitedById = getInvitedById();
    if (!invitedById)
        return;
    localStorage.setItem(LOCAL_STORAGE_KEY, invitedById);
}
exports.storeReferrer = storeReferrer;
function clearReferrer() {
    localStorage.removeItem(LOCAL_STORAGE_KEY);
}
exports.clearReferrer = clearReferrer;
